var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.741 10.8839C28.741 10.8839 28.4871 9.11941 27.7051 8.34463C26.7148 7.32491 25.6078 7.31991 25.1 7.25993C21.4641 7 16.0051 7 16.0051 7H15.9949C15.9949 7 10.5359 7 6.9 7.25993C6.39219 7.31991 5.28516 7.32491 4.29492 8.34463C3.51289 9.11941 3.26406 10.8839 3.26406 10.8839C3.26406 10.8839 3 12.9583 3 15.0278V16.9672C3 19.0367 3.25898 21.1111 3.25898 21.1111C3.25898 21.1111 3.51289 22.8756 4.28984 23.6504C5.28008 24.6701 6.58008 24.6351 7.15898 24.7451C9.24102 24.94 16 25 16 25C16 25 21.4641 24.99 25.1 24.7351C25.6078 24.6751 26.7148 24.6701 27.7051 23.6504C28.4871 22.8756 28.741 21.1111 28.741 21.1111C28.741 21.1111 29 19.0417 29 16.9672V15.0278C29 12.9583 28.741 10.8839 28.741 10.8839ZM13.3137 19.3216V12.1286L20.3367 15.7376L13.3137 19.3216Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/Youtube.91c6646a2581b84c10e925a3248de88a.svg";
export { ForwardRef as ReactComponent };